// Web push in the admin (plan P13, contract C-4 /device): what this browser
// can do, and the device registration for a subscription.

// The service worker the admin registers for push, served unhashed from the
// site root (CRA copies public/ as is) with root scope.
export const SW_PATH = '/notify-sw.js'

// Where this browser's push device id is remembered, so turning push off
// unregisters the same device (best effort: a blocked storage only means
// the device is found through GET /device's `current` instead).
export const DEVICE_KEY = 'edxr-notify-web-device'

// Web push needs all three. Safari on iOS has them only for a site added to
// the Home Screen, so elsewhere the opt-in is not shown at all.
export const pushSupported = (win = typeof window === 'undefined' ? undefined : window) =>
  Boolean(win && 'Notification' in win && 'PushManager' in win && win.navigator && 'serviceWorker' in win.navigator)

// A VAPID public key (base64url, no padding) as the bytes
// PushManager.subscribe takes as applicationServerKey.
export const urlBase64ToUint8Array = text => {
  const padded = `${text}${'='.repeat((4 - (text.length % 4)) % 4)}`.replace(/-/g, '+').replace(/_/g, '/')
  const raw = window.atob(padded)
  const out = new Uint8Array(raw.length)
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i)
  return out
}

// The C-4 DeviceRegister body for a PushSubscription. token is the
// endpoint; token, p256dh and auth are write-only (never shown again).
export const subscriptionBody = (subscription, { deviceName, locale, timezone } = {}) => {
  const json = subscription && typeof subscription.toJSON === 'function' ? subscription.toJSON() : subscription || {}
  const keys = json.keys || {}
  return {
    platform: 'web',
    provider: 'webpush',
    environment: 'production',
    app: 'admin',
    token: json.endpoint || subscription.endpoint,
    p256dh: keys.p256dh,
    auth: keys.auth,
    deviceName,
    locale,
    timezone
  }
}

// "Chrome on macOS": a device label the person recognises in a device list.
export const browserLabel = (ua = typeof navigator === 'undefined' ? '' : navigator.userAgent || '') => {
  const browser = /Edg\//.test(ua) ? 'Edge' : /Firefox\//.test(ua) ? 'Firefox' : /Chrome\//.test(ua) ? 'Chrome' : /Safari\//.test(ua) ? 'Safari' : 'Browser'
  const os = /Mac OS X|Macintosh/.test(ua) ? (/iPhone|iPad/.test(ua) ? 'iOS' : 'macOS') : /Windows/.test(ua) ? 'Windows' : /Android/.test(ua) ? 'Android' : /Linux/.test(ua) ? 'Linux' : ''
  return os ? `${browser} on ${os}` : browser
}

export const rememberDevice = value => {
  try {
    if (value) window.localStorage.setItem(DEVICE_KEY, JSON.stringify(value))
    else window.localStorage.removeItem(DEVICE_KEY)
  } catch (e) {
    // Storage blocked: the device is found through GET /device instead.
  }
}

export const rememberedDevice = () => {
  try {
    const v = JSON.parse(window.localStorage.getItem(DEVICE_KEY) || 'null')
    return v && v.id ? v : null
  } catch (e) {
    return null
  }
}
